 document.addEventListener("DOMContentLoaded", () => {
    const popcornIcons = document.querySelectorAll('.popcorn-icon');

    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;

      popcornIcons.forEach(icon => {
        if (scrollPosition > 00) {
          const rotation = scrollPosition / 10;
          const scale = 1 + scrollPosition / 1000;
          icon.style.transform = `translateY(0) rotate(${rotation}deg) scale(${scale})`;
        } else {
          icon.style.transform = `translateY(100px)`;
        }
      });
    });
  });



$(".testimonial-custom-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2.png?v=1742898764"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_1.png?v=1742898765"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$(".tow-custom-testimonials-slider").slick({
    slidesToShow: 2,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2.png?v=1742898764"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_1.png?v=1742898765"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$(".cust-product-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2.png?v=1742898764"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_1.png?v=1742898765"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$(".cust-logo-slider").slick({
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  // Enable pagination dots
    arrows: true, // Enable navigation arrows
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
    responsive: [
        {
            breakpoint: 1024, // Tablets
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, // Mobile
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$(".cust-testimonials-slider").slick({
    slidesToShow: 3,
    infinite: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_1.png?v=1743163670"></button>',
    nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_2.png?v=1743163670"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

$(".goodness-slider").slick({
    slidesToShow: 4,
    infinite: true,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    dots: true,  
    arrows: true,
    prevArrow: '<button class="slick-prev custom-prev" aria-label="Name" role="button"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
    nextArrow: '<button class="slick-next custom-next" aria-label="Name" role="button"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
    responsive: [
        {
            breakpoint: 1024, 
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 768, 
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


$('.slider-content').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  fade: false,
  speed: 1000,
  asNavFor: '.slider-thumb',
  prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
  nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
});

$('.slider-thumb').slick({
  slidesToShow: 7,
  slidesToScroll: 7,
  asNavFor: '.slider-content',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
});


function initMobileSlick() {
  if ($(window).width() <= 767) {
    if (!$('.our_customer_like').hasClass('slick-initialized')) {
      $(".our_customer_like").slick({
        slidesToShow: 2, // default for ≤767
        infinite: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,  
        arrows: true,
        prevArrow: '<button class="slick-prev custom-prev"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_2_2.png?v=1744104807"></button>',
        nextArrow: '<button class="slick-next custom-next"><img src="https://cdn.shopify.com/s/files/1/0518/6243/8070/files/Vector_1_3.png?v=1744104832"></button>',
        responsive: [
          {
            breakpoint: 525,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  } else {
    if ($('.our_customer_like').hasClass('slick-initialized')) {
      $('.our_customer_like').slick('unslick'); // remove slider on desktop
    }
  }
}

$(document).ready(function() {
  initMobileSlick();
});

$(window).on('resize', function() {
  initMobileSlick();
});

